<template>
  <div class="home">
    <!-- Banner轮播 -->
    <section class="banner">
      <div class="banner-slides" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
        <div 
          v-for="(banner, index) in config.home.banners" 
          :key="index"
          class="banner-slide"
        >
          <div class="banner-bg" :style="{ backgroundImage: `url(${banner.image})` }"></div>
          <div class="banner-content container">
            <h2>{{ banner.title }}</h2>
            <p>{{ banner.subtitle }}</p>
          </div>
        </div>
      </div>
      <div class="banner-dots">
        <span 
          v-for="(_, index) in config.home.banners" 
          :key="index"
          :class="{ active: currentSlide === index }"
          @click="currentSlide = index"
        ></span>
      </div>
    </section>
    
    <!-- 核心服务 -->
    <section class="section services">
      <div class="container">
        <div class="page-title">
          <h2>我们的成长</h2>
          <p>用数字点亮好奇心，陪伴每一次探索</p>
        </div>
        <div class="services-grid grid grid-4">
          <div 
            v-for="service in config.home.services" 
            :key="service.id"
            class="service-card card"
          >
            <span class="service-icon">{{ service.icon }}</span>
            <h3>{{ service.title }}</h3>
            <p>{{ service.desc }}</p>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 关于我们简介 -->
    <section class="section section-gray about-intro">
      <div class="container">
        <div class="about-intro-content">
          <div class="about-intro-text">
            <h2>关于趣味数语探索</h2>
            <p>{{ config.about.intro }}</p>
            <router-link to="/about" class="btn btn-primary">了解更多</router-link>
          </div>
          <div class="about-intro-image">
            <img src="https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?w=600&h=400&fit=crop" alt="趣味数语探索" />
          </div>
        </div>
      </div>
    </section>
    
    <!-- 名师团队 -->
    <section class="section team">
      <div class="container">
        <div class="page-title">
          <h2>我们的伙伴</h2>
          <p>专业、爱心、责任的探索团队</p>
        </div>
        <div class="team-grid grid grid-4">
          <div 
            v-for="member in config.home.team" 
            :key="member.id"
            class="team-card card"
          >
            <div class="team-avatar">
              <img :src="member.avatar" :alt="member.name" />
            </div>
            <h3>{{ member.name }}</h3>
            <span class="team-role">{{ member.role }}</span>
            <p>{{ member.intro }}</p>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 最新动态 -->
    <!-- <section class="section section-gray news">
      <div class="container">
        <div class="page-title">
          <h2>最新动态</h2>
          <p>关注我们，了解更多精彩</p>
        </div>
        <div class="news-list">
          <div 
            v-for="item in config.home.news" 
            :key="item.id"
            class="news-item card"
          >
            <span class="news-tag">{{ item.type }}</span>
            <h3>{{ item.title }}</h3>
            <span class="news-date">{{ item.date }}</span>
          </div>
        </div>
        <div class="text-center" style="margin-top: 40px;">
          <router-link to="/news" class="btn btn-primary">查看更多</router-link>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentSlide: 0,
      slideInterval: null
    }
  },
  mounted() {
    this.startAutoSlide()
  },
  beforeDestroy() {
    this.stopAutoSlide()
  },
  methods: {
    startAutoSlide() {
      this.slideInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.config.home.banners.length
      }, 4000)
    },
    stopAutoSlide() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval)
      }
    }
  }
}
</script>

<style scoped>
.banner {
  position: relative;
  height: 500px;
  overflow: hidden;
}

.banner-slides {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
}

.banner-slide {
  min-width: 100%;
  height: 100%;
  position: relative;
}

.banner-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.banner-bg::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(118, 75, 162, 0.8) 100%);
}

.banner-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
}

.banner-content h2 {
  font-size: 48px;
  margin-bottom: 20px;
  animation: fadeIn 0.8s ease;
}

.banner-content p {
  font-size: 20px;
  opacity: 0.9;
  animation: fadeIn 0.8s ease 0.2s both;
}

.banner-dots {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.banner-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.banner-dots span.active {
  background: #fff;
  transform: scale(1.2);
}

.services-grid .card {
  text-align: center;
  padding: 35px 25px;
}

.service-icon {
  font-size: 50px;
  display: block;
  margin-bottom: 20px;
}

.services-grid h3 {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 15px;
}

.services-grid p {
  color: #666;
  font-size: 14px;
  line-height: 1.8;
}

.about-intro-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.about-intro-text h2 {
  font-size: 32px;
  color: #2c3e50;
  margin-bottom: 25px;
}

.about-intro-text p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 30px;
}

.about-intro-image img {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.team-card {
  text-align: center;
  padding: 30px 20px;
}

.team-avatar {
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #e8e8e8;
}

.team-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.team-card h3 {
  font-size: 18px;
  color: #2c3e50;
  margin-bottom: 8px;
}

.team-role {
  display: block;
  font-size: 14px;
  color: #667eea;
  margin-bottom: 15px;
}

.team-card p {
  color: #666;
  font-size: 14px;
}

.news-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.news-item {
  padding: 25px;
}

.news-tag {
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 12px;
  border-radius: 15px;
  margin-bottom: 15px;
}

.news-item h3 {
  font-size: 16px;
  color: #2c3e50;
  margin-bottom: 15px;
  line-height: 1.6;
}

.news-date {
  font-size: 13px;
  color: #999;
}

.text-center {
  text-align: center;
}

@media (max-width: 992px) {
  .about-intro-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .about-intro-image {
    order: -1;
  }
}

@media (max-width: 768px) {
  .banner {
    height: 400px;
  }
  
  .banner-content h2 {
    font-size: 32px;
  }
  
  .banner-content p {
    font-size: 16px;
  }
  
  .about-intro-text h2 {
    font-size: 26px;
  }
  
  .news-list {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .banner {
    height: 300px;
  }
  
  .banner-content h2 {
    font-size: 26px;
  }
}
</style>
